document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.moodboard-section');

  sections.forEach(section => {
    const gridItems = section.querySelectorAll('.moodboard-grid__item');
    const overlay = section.querySelector('.moodboard-overlay');
    const scroller = section.querySelector('.moodboard-scroller');
    let detailItems = section.querySelectorAll('.moodboard-detail');
    const closeBtn = section.querySelector('.moodboard-overlay__close');
    const prevBtn = section.querySelector('.moodboard-nav--prev');
    const nextBtn = section.querySelector('.moodboard-nav--next');
    
    let currentIndex = 0;
    let track = null; 
    
    // 1024px to include Tablets
    const isMobile = () => window.innerWidth < 1024;

    // Hint Timer Variables
    let hintTimeout;

    // --- 0. DOM STRUCTURE UPGRADE (Vertical Track) ---
    if (scroller && detailItems.length > 0) {
        track = document.createElement('div');
        track.className = 'moodboard-track';
        detailItems.forEach(item => track.appendChild(item));
        scroller.appendChild(track);
        detailItems = track.querySelectorAll('.moodboard-detail');
    }

    // --- 1. VERTICAL ENGINE (TikTok Style) ---
    let startY = 0;
    let startX = 0; 
    let initialScrollTop = 0; 
    let isDragging = false;
    let startAtTop = true;
    let startAtBottom = true;

    function updateVerticalSlide(index) {
        if (!track) return;
        
        if (isMobile()) {
            track.style.transform = `translateY(-${index * 100}%)`;
        } else {
            track.style.transform = 'none';
            updateDesktopView(index);
        }

        const hint = overlay.querySelector('.moodboard-swipe-hint');
        if (hint) {
            hint.classList.remove('is-visible');
            clearTimeout(hintTimeout);
        }
    }

    if (scroller) {
      scroller.addEventListener('touchstart', (e) => {
          startY = e.touches[0].clientY;
          startX = e.touches[0].clientX; 
          isDragging = true;
          
          const hint = overlay.querySelector('.moodboard-swipe-hint');
          if (hint && hint.classList.contains('is-visible')) {
              hint.classList.remove('is-visible');
              clearTimeout(hintTimeout);
          }

          const currentDetail = detailItems[currentIndex];
          const content = currentDetail ? currentDetail.querySelector('.moodboard-detail__content') : null;
          const isHeroSwipe = e.target.closest('.moodboard-hero-wrapper') || e.target.closest('.moodboard-detail__mobile-header');

          if (content) {
            initialScrollTop = content.scrollTop;
          }

          if (isHeroSwipe) {
              startAtTop = true;
              startAtBottom = true;
          } else if (content) {
              const scrollTop = content.scrollTop;
              const maxScroll = content.scrollHeight - content.clientHeight;
              startAtTop = scrollTop <= 2;
              startAtBottom = scrollTop >= maxScroll - 2;
          } else {
              startAtTop = true;
              startAtBottom = true;
          }
      }, { passive: true });

      scroller.addEventListener('touchend', (e) => {
          if (!isDragging) return;
          isDragging = false;
          
          const endY = e.changedTouches[0].clientY;
          const endX = e.changedTouches[0].clientX; 

          const diffY = startY - endY;
          const diffX = startX - endX;

          // Horizontal Axis Lock: If swiping slider, don't change page
          if (Math.abs(diffX) > Math.abs(diffY)) return;

          // Scroll Lock: If reading text, don't change page
          const currentDetail = detailItems[currentIndex];
          const content = currentDetail ? currentDetail.querySelector('.moodboard-detail__content') : null;
          if (content) {
             const currentScrollTop = content.scrollTop;
             if (Math.abs(currentScrollTop - initialScrollTop) > 10) return;
          }

          const threshold = 80; 
          
          if (diffY > threshold) {
              if (startAtBottom && currentIndex < detailItems.length - 1) {
                  currentIndex++;
                  updateVerticalSlide(currentIndex);
              }
          } 
          else if (diffY < -threshold) {
               if (startAtTop && currentIndex > 0) {
                   currentIndex--;
                   updateVerticalSlide(currentIndex);
               }
          }
      }, { passive: true });
    }

    // --- 2. HORIZONTAL ENGINE (Hero Slider - Touch & Mouse) ---
    detailItems.forEach((detail, index) => {
      const heroSlider = detail.querySelector('.moodboard-hero-slider');
      const heroTrack = detail.querySelector('.moodboard-hero-slider__track');
      const slides = detail.querySelectorAll('.moodboard-hero-slide');
      const dots = detail.querySelectorAll('.hero-dot');
      const arrowPrev = detail.querySelector('.hero-nav--prev');
      const arrowNext = detail.querySelector('.hero-nav--next');
      
      let heroIndex = 0; 

      if (heroSlider && heroTrack) {
          heroSlider.style.overflowX = 'hidden'; 
          heroSlider.style.scrollSnapType = 'none'; 
          heroTrack.style.display = 'flex';
          heroTrack.style.width = '100%'; 
          heroTrack.style.height = '100%';
          heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
          heroTrack.style.willChange = 'transform';
          
          slides.forEach(slide => {
              slide.style.flex = '0 0 100%';      
              slide.style.width = '100%';         
              slide.style.maxWidth = '100%';      
              slide.style.boxSizing = 'border-box';
          });
      }

      function updateHeroSlide(newIndex) {
          if (newIndex < 0) newIndex = slides.length - 1; 
          if (newIndex >= slides.length) newIndex = 0;

          heroIndex = newIndex;

          if (heroTrack) {
              heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
              heroTrack.style.transform = `translateX(-${heroIndex * 100}%)`;
          }

          dots.forEach(d => d.classList.remove('is-active'));
          if (dots[heroIndex]) dots[heroIndex].classList.add('is-active');
      }

      // --- TOUCH Logic (Mobile/Tablet) ---
      let hStartX = 0;
      let hStartY = 0;
      let hIsDragging = false;
      let isHorizontalSwipe = false;
      let isDirectionDetermined = false;

      if (heroSlider) {
          heroSlider.addEventListener('touchstart', (e) => {
              hStartX = e.touches[0].clientX;
              hStartY = e.touches[0].clientY;
              hIsDragging = true;
              isDirectionDetermined = false;
              isHorizontalSwipe = false;
              if (heroTrack) heroTrack.style.transition = 'none';
          }, { passive: true });

          heroSlider.addEventListener('touchmove', (e) => {
              if (!hIsDragging) return;

              const currentX = e.touches[0].clientX;
              const currentY = e.touches[0].clientY;
              const diffX = currentX - hStartX;
              const diffY = currentY - hStartY;

              if (!isDirectionDetermined) {
                  if (Math.abs(diffX) < 5 && Math.abs(diffY) < 5) return;
                  isDirectionDetermined = true;
                  if (Math.abs(diffX) > Math.abs(diffY)) {
                      isHorizontalSwipe = true;
                  } else {
                      isHorizontalSwipe = false;
                      if (heroTrack) heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
                  }
              }

              if (isHorizontalSwipe) {
                  e.stopPropagation(); 
                  if (heroTrack) {
                      const slideWidth = heroSlider.offsetWidth;
                      const currentOffset = -heroIndex * slideWidth;
                      const newOffset = currentOffset + diffX;
                      heroTrack.style.transform = `translateX(${newOffset}px)`;
                  }
              }
          }, { passive: false }); 

          heroSlider.addEventListener('touchend', (e) => {
              if (!hIsDragging) return;
              hIsDragging = false;

              if (!isHorizontalSwipe) {
                   if (heroTrack) {
                       heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
                       heroTrack.style.transform = `translateX(-${heroIndex * 100}%)`;
                   }
                  return;
              }

              e.stopPropagation(); 

              const hEndX = e.changedTouches[0].clientX;
              const diffX = hEndX - hStartX;
              const threshold = 50; 

              if (diffX > threshold) {
                  updateHeroSlide(heroIndex - 1);
              } else if (diffX < -threshold) {
                  updateHeroSlide(heroIndex + 1);
              } else {
                  updateHeroSlide(heroIndex);
              }
          }, { passive: true });

          // --- MOUSE Logic (Desktop) ---
          heroSlider.addEventListener('mousedown', (e) => {
              hStartX = e.clientX;
              hIsDragging = true;
              isDirectionDetermined = true; // Always horizontal on mouse drag
              isHorizontalSwipe = true;
              
              if (heroTrack) heroTrack.style.transition = 'none';
              e.preventDefault(); // Prevent default image drag
          });

          heroSlider.addEventListener('mousemove', (e) => {
              if (!hIsDragging || !isHorizontalSwipe) return;
              e.preventDefault();

              const currentX = e.clientX;
              const diffX = currentX - hStartX;

              if (heroTrack) {
                  const slideWidth = heroSlider.offsetWidth;
                  const currentOffset = -heroIndex * slideWidth;
                  const newOffset = currentOffset + diffX;
                  heroTrack.style.transform = `translateX(${newOffset}px)`;
              }
          });

          const endMouseDrag = (e) => {
              if (!hIsDragging) return;
              hIsDragging = false;

              const diffX = e.clientX - hStartX;
              const threshold = 50;

              if (diffX > threshold) {
                  updateHeroSlide(heroIndex - 1);
              } else if (diffX < -threshold) {
                  updateHeroSlide(heroIndex + 1);
              } else {
                  updateHeroSlide(heroIndex);
              }
          };

          heroSlider.addEventListener('mouseup', endMouseDrag);
          heroSlider.addEventListener('mouseleave', endMouseDrag);
      }

      // Arrows
      if (arrowPrev) {
        arrowPrev.addEventListener('click', (e) => {
          e.stopPropagation();
          updateHeroSlide(heroIndex - 1);
        });
      }
      if (arrowNext) {
        arrowNext.addEventListener('click', (e) => {
          e.stopPropagation();
          updateHeroSlide(heroIndex + 1);
        });
      }

      // Dots
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          updateHeroSlide(dotIndex);
        });
      });

      // --- 3. Content Scroll Hint Logic ---
      const content = detail.querySelector('.moodboard-detail__content');
      if (content) {
          content.addEventListener('scroll', () => {
              if (!isMobile()) return;
              
              const hint = overlay.querySelector('.moodboard-swipe-hint');
              if (!hint) return;

              const isAtBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 20;
              const isLastSlide = index === detailItems.length - 1;

              if (isAtBottom && !isLastSlide) {
                  if (!hint.classList.contains('is-visible')) {
                      hint.classList.add('is-visible');
                      
                      clearTimeout(hintTimeout);
                      hintTimeout = setTimeout(() => {
                          hint.classList.remove('is-visible');
                      }, 2000);
                  }
              } else {
                  if (!isAtBottom) {
                      hint.classList.remove('is-visible');
                      clearTimeout(hintTimeout);
                  }
              }
          }, { passive: true });
      }
    });

    // --- Open Modal ---
    gridItems.forEach(item => {
      item.addEventListener('click', () => {
        currentIndex = parseInt(item.dataset.index);
        openModal(currentIndex);
      });
    });

    function openModal(index) {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden'; 

      const activeDetail = detailItems[index];
      if (activeDetail) {
        const scrollableContent = activeDetail.querySelector('.moodboard-detail__content');
        if (scrollableContent) scrollableContent.scrollTop = 0;
      }
      
      updateVerticalSlide(index);

      // --- INITIAL HINT (Once per session) ---
      if (isMobile()) {
        const hint = overlay.querySelector('.moodboard-swipe-hint');
        const hasShownInitialHint = sessionStorage.getItem('moodboardSwipeHintShown');
        
        if (hint && !hasShownInitialHint) {
           setTimeout(() => {
               hint.classList.add('is-visible');
               sessionStorage.setItem('moodboardSwipeHintShown', 'true');
               
               clearTimeout(hintTimeout);
               hintTimeout = setTimeout(() => {
                   hint.classList.remove('is-visible');
               }, 3000);
           }, 500);
        }
      }
    }

    // --- Close Modal ---
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });

    function closeModal() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      const hint = overlay.querySelector('.moodboard-swipe-hint');
      if(hint) {
          hint.classList.remove('is-visible');
          clearTimeout(hintTimeout);
      }
    }

    // --- Desktop View ---
    function updateDesktopView(index) {
      detailItems.forEach(d => d.classList.remove('is-active'));
      if(detailItems[index]) {
        detailItems[index].classList.add('is-active');
      }
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = detailItems.length - 1;
        }
        updateVerticalSlide(currentIndex);
      });

      nextBtn.addEventListener('click', () => {
        if (currentIndex < detailItems.length - 1) {
          currentIndex++;
        } else {
          currentIndex = 0;
        }
        updateVerticalSlide(currentIndex);
      });
    }

    window.addEventListener('resize', () => {
      if (overlay.classList.contains('is-open')) {
          updateVerticalSlide(currentIndex);
      }
    });
  });
});